var React = require('react');

function IconMarker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M21.183 1.06a.815.815 0 0 1 .602.345c.143.2.215.415.215.645 0 3.611-.903 6.965-2.709 10.06a20.046 20.046 0 0 1-7.18 7.181C9.015 21.097 5.66 22 2.05 22c-.23 0-.445-.072-.645-.215a.815.815 0 0 1-.344-.602L.029 16.711a.97.97 0 0 1 .086-.688.926.926 0 0 1 .516-.473l4.815-2.063c.2-.086.416-.108.645-.065.23.043.416.165.56.366l2.106 2.58a15.114 15.114 0 0 0 4.493-3.14 15.796 15.796 0 0 0 3.117-4.471l-2.58-2.15a1.03 1.03 0 0 1-.343-.537 1.072 1.072 0 0 1 .043-.667L15.55.588a.948.948 0 0 1 .473-.473.97.97 0 0 1 .688-.086l4.472 1.032z"}));
}

IconMarker.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = IconMarker;

IconMarker.default = IconMarker;
